import { render } from "./ProductionStatus.vue?vue&type=template&id=7b5b9b9a"
import script from "./ProductionStatus.vue?vue&type=script&lang=js"
export * from "./ProductionStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__